module.exports = __webpack_public_path__ + "img/bear1.ebd2e6ae.svg";